import { useContext } from "react";
import { StoreContext } from "./use-store";
function useDispatch() {
  const store = useContext(StoreContext);
  return store.dispatch;
}
export {
  useDispatch
};
//# sourceMappingURL=use-dispatch.js.map